'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Position relative container for positioning DropdownMenu component
 */

var Dropdown = function Dropdown(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(_Base2.default, _extends({}, props, {
    className: 'Dropdown',
    baseStyle: {
      position: 'relative'
    } }));
};

exports.default = Dropdown;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rebass/dist/Dropdown.js
 ** module id = 202
 ** module chunks = 0
 **/